<template>
  <div
    class="w-full flex flex-col xl:flex-row gap-2 max-w-[2300px] mx-auto"
    :class="{
      'bg-untitled-gray-50': !isKintz,
    }"
  >
    <div
      class="flex-1 flex flex-col gap-2 p-2 sm:p-4"
      :class="{
        'lg:border-r border-untitled-gray-300': showRightSection
      }"
    >
      <!-- tabs -->
      <HomeMainTabs v-if="!isKintz" />
      <AppKintzHomeMainTabs v-if="isKintz"/>
      <!-- end of tabs -->
      <div class="w-full">
        <KeepAlive>
          <component :is="display" />
        </KeepAlive>
      </div>
    </div>
    <div v-if="showRightSection" class="w-full xl:w-2/6 flex flex-col gap-2 p-2 sm:p-4">
      <HomeRightSection />
    </div>
  </div>
  <el-backtop :right="190" :bottom="20" />
</template>

<script setup>
import HomeMainTabs from "./partials/HomeMainTabs.vue";
import HomeRightSection from "./HomeRightSection.vue";
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";

import { storeToRefs } from "pinia";
import { defineAsyncComponent, onMounted, onUnmounted, inject } from "vue";
import { computed } from "vue";
// import { useAllAvailableCourseStore } from "@/stores/useAllAvailableCourse.store";
import { ElBacktop } from "element-plus";
import FeaturedContent from "@/components/new-home/main-display/FeaturedContent.vue";
import AppKintzHomeMainTabs from "../layout/kintz-app/partials/AppKintzHomeMainTabs.vue";
import eventBus from "@/plugins/eventBus";

const EnrolledCourses = defineAsyncComponent(() =>
  import("./main-display/EnrolledCourses.vue")
);
const LearningPath = defineAsyncComponent(() =>
  import("./main-display/LearningPath.vue")
);
const AvailableContent = defineAsyncComponent(() =>
  import("./main-display/AvailableContent.vue")
);

// const allAvailableCourseStore = useAllAvailableCourseStore();
const homeMainTabsStore = useHomeTabsStore();
const { selectedMainTab, showRightSection } = storeToRefs(homeMainTabsStore);

const isKintz = inject("kintz-app", false); // Check if the app is Kintz
const display = computed(() => {
  if (selectedMainTab.value === "enrolled") {
    return EnrolledCourses;
  }
  if (selectedMainTab.value === "playlist") {
    return LearningPath;
  }
  if (selectedMainTab.value === "content") {
    return AvailableContent;
  }
  return FeaturedContent;
});

onMounted(() => {
  // allAvailableCourseStore.handleFetchCategoriesWithCourses();
  eventBus.$on("show-right-section", homeMainTabsStore.handleShowRightSection);
});

onUnmounted(() => {
  eventBus.$off("show-right-section", homeMainTabsStore.handleShowRightSection);
});
</script>

<style lang="scss" scoped></style>
